function CartPage(){
    return(
        <>
            <h1>Cart</h1>
        </>
    );
}

export default CartPage;